<template>
  <div class="layout">
    <header class="header" v-if="showHeader">
      <div class="header-left">
        <img src="@/assets/logo.png" alt="Logo" class="header-logo" />
      </div>
      <nav class="header-nav">
        <Menubar :model="menuItems" class="header-menu" />
      </nav>
      <div class="header-actions">
        <div class="user-menu">
          <Menu ref="userMenu" :model="userMenuItems" :popup="true" />
          <Button
            icon="pi pi-user"
            class="p-button-rounded p-button-text"
            @click="toggleUserMenu"
          />
        </div>
      </div>
    </header>
    <main class="main-content app-background">
      <router-view />
    </main>
    <Footer v-if="isAuthenticated" />
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import Menubar from 'primevue/menubar'
import Menu from 'primevue/menu'
import Button from 'primevue/button'
import Footer from '@/components/common/Footer.vue'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    Menubar,
    Menu,
    Button,
    Footer
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const userMenu = ref()

    const isAuthenticated = computed(() => {
      return store.getters['auth/isAuthenticated']
    })

    const isSuperAdmin = computed(() => {
      return store.getters['auth/isSuperAdmin']
    })

    const showHeader = computed(() => {
      return isAuthenticated.value && route.path !== '/login'
    })

    const menuItems = computed(() => {
      const items = [];
      if(isAuthenticated.value){
        items.push(
          {
            label: 'Tableau de bord',
            icon: 'pi pi-home',
            command: () => router.push('/')
          },
          {
            label: 'Catégories',
            icon: 'pi pi-tags',
            command: () => router.push('/categories')
          },
          {
            label: 'Questions',
            icon: 'pi pi-question-circle',
            command: () => router.push('/questions')
          },
          {
            label: 'Documentation',
            icon: 'pi pi-book',
            command: () => router.push('/documentation')
          },
          {
            label: 'Notifications',
            icon: 'pi pi-bell',
            command: () => router.push('/notifications')
          }
        ); 
        if (isSuperAdmin.value) {
          items.push({
            label: 'Espace Admin',
            icon: 'pi pi-cog',
            items: [
              {
                label: 'Utilisateurs',
                icon: 'pi pi-users',
                command: () => router.push('/users')
              },
              {
                label: 'Conversations',
                icon: 'pi pi-comments',
                command: () => router.push('/conversations')
              },
              {
                label: 'Instructions IA',
                icon: 'pi pi-book',
                command: () => router.push('/instructions')
              }
            ]
          })
        }
      }
      return items
    })

    const userMenuItems = [
      {
        label: 'Mon Profil',
        icon: 'pi pi-user',
        command: () => router.push('/profile')
      },
      {
        label: 'Déconnexion',
        icon: 'pi pi-sign-out',
        command: () => {
          store.dispatch('auth/logout')
          router.push('/login')
        }
      }
    ]

    const toggleUserMenu = (event) => {
      userMenu.value.toggle(event)
    }

    return {
      menuItems,
      userMenuItems,
      userMenu,
      toggleUserMenu,
      isAuthenticated,
      showHeader
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  background: #f6f8fa;
}

.header {
  height: 64px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  gap: 2rem;
  position: sticky;
  top: 0;
  z-index: 10;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-logo {
  height: 36px;
}

.header-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2e7d6b;
  letter-spacing: 1px;
}

.header-nav {
  flex: 1;
  display: flex;
  align-items: center;
}

.main-content {
  flex: 1;
  padding: 1rem;
}

:deep(.p-menubar) {
  background: transparent;
  border: none;
  padding: 0;
  width: 100%;

  .p-menubar-root-list {
    gap: 0.5rem;
  }

  .p-menuitem {
    position: relative;
  }

  .p-menuitem-link {
    padding: 0.75rem 1.25rem;
    border-radius: 6px;
    transition: all 0.2s;

    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }

    .p-menuitem-icon {
      color: #4b5563;
    }

    .p-menuitem-text {
      color: #374151;
      font-weight: 500;
    }
  }
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-menu {
  position: relative;
}
</style> 